<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MkGdf5/tc-custom/9781466856325.jpg?1730578551557" alt="This image is the cover for the book How It Was for Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How It Was for Me
      </h1>
      <p class="bookDescription body article font2">
        <b>From the Pulitzer Prize–winning author of <i>Less</i>, a debut collection of ten short stories featuring characters haunted by their decisions and memories.</b><br/><br/>With a classic storyteller’s gift for nuance and understanding, and a poet’s grace for language, Andrew Sean Greer makes a remarkable debut with <i>How It Was for Me</i>. Focusing on the lives of eleven people—those who have discovered and been uncovered by the truths of life, those who have sacrificed, those who have fallen—Greer fashions a unified, stunning portrait of America, one with the ultimate force and candor of testimonial.<br/><br/><b>Praise for <i>How It Was for Me</i></b><br/><br/><b>An <i>LA Weekly</i> Top Ten Book of the Year</b><br/><br/>“Crystal-like clarity . . . outstanding . . . nuanced language . . . Greer is a writer worth watching.” —Martin Wilson, <i>The Austin Chronicle</i><br/><br/>“Impressive . . . Greer’s descriptive talents are immense. . . . While these stories are thick with melancholy, their frankness is refreshing.” —<i>The New York Times Book Review</i><br/><br/>“Greer reveals sensitive, unpredictable characters in direct but subtle prose, saving his most powerful stories for the end. . . . Many of these stories project that same kind of effortlessness—suggesting that more strong writing from Greer will follow.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Sean Greer
      </h2>
      
      <p class="authorDescription body article">Andrew Sean Greer is the bestselling author of several works of fiction, including <I>The Story of a Marriage</I>, which <I>The New York Times</I> has called an "inspired, lyrical novel," and <I>The Confessions of Max Tivoli</I>, which was named a best book of 2004 by the San Francisco Chronicle and the Chicago Tribune. His stories have appeared in <I>The New Yorker</I>, <I>Esquire</I>, and <I>The Paris Review</I>. He is the recipient of the Northern California Book Award, the California Book Award, the New York Public Library Young Lions Award, the O Henry Award for short fiction and fellowships from the National Endowment for the Arts and the New York Public Library. Greer lives in San Francisco.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Picador
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2102423c